export default {
  en: {
    title: 'Buy now. Pay with Klarna at your own pace.',
    subTitle: 'Get what you love, choose how you pay.',
    timelineHeader: 'How it works',
    timelineItems: [
      {
        title: 'At checkout select Klarna',
        description: ''
      },
      {
        title: 'Choose your payment plan',
        description: 'Different payment plans may be shown depending on the purchase amount and credit score.'
      },
      {
        title: 'Complete your checkout',
        description: 'The amount will be charged based on the payment plan you chose.'
      }
    ]
  },
  fr: {
    title: 'Achetez maintenant. Payez avec Klarna à votre rythme.',
    subTitle: 'Obtenez ce que vous aimez, choisissez le mode de paiement.',
    timelineHeader: 'Comment ça marche?',
    timelineItems: [
      {
        title: 'Au moment du paiement, choisissez Klarna',
        description: ''
      },
      {
        title: 'Choisissez votre plan de paiement',
        description: 'Différents plans de paiement peuvent être proposés en fonction du montant de l\'achat et de votre solvabilité.'
      },
      {
        title: 'Terminez votre commande',
        description: 'Le montant sera débité en fonction du plan de paiement que vous avez choisi.'
      }
    ]
  }
}
